import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);

  return null;
};
